module.exports = __webpack_public_path__ + "img/cs-dots.8701764b.jpg";